"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var ButtonPrimary_1 = __importDefault(require("atomicComponents/atoms/Buttons/ButtonPrimary"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var FieldCheckbox_1 = __importDefault(require("components/Form/FieldCheckbox"));
var Autocomplete_1 = __importDefault(require("shared/components/Form/Select/Autocomplete"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var backend_1 = require("utils/backend");
var validators_1 = require("utils/form/validators");
var ordered_1 = require("utils/selectors/ordered");
var AssignAccountantModal = function (_a) {
    var company = _a.company, props = __rest(_a, ["company"]);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'companies', where: ['isAccountingFirm', '==', true], storeAs: 'accountingFirms' },
        { collection: 'users', where: ['isAccountant', '==', true], storeAs: 'accountants' },
    ]; });
    var accountants = (0, react_redux_1.useSelector)(ordered_1.selectAccountants);
    var accountingFirms = (0, react_redux_1.useSelector)(ordered_1.selectAccountingFirms);
    var assignCompany = (0, backend_1.callBackendFn)('userCompanies-attachCompanyToAccountant');
    if (!(0, react_redux_firebase_1.isLoaded)(accountants) || !(0, react_redux_firebase_1.isLoaded)(accountingFirms)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({}, props, { label: "Assign accountant" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function (v) { return __awaiter(void 0, void 0, void 0, function () {
                var e_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, assignCompany({ companyId: company.id, accountantId: v.accountantId, force: v.force })];
                        case 1:
                            _b.sent();
                            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                            return [2 /*return*/, undefined];
                        case 2:
                            e_1 = _b.sent();
                            return [2 /*return*/, { force: 'Need to tick checkbox when company already has accounting firm' }];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }, validate: function (fV) { return (0, validators_1.requiredFields)(['accountantId'])(__assign({}, fV)); }, subscription: { values: true, submitting: true } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting, values = _a.values;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Assign accountant" })) }), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [(company.accountingFirmId || company.accountantCreatorId) && ((0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(FieldCheckbox_1.default, { name: "force" }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: ["Accounting Firm", (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "accountingFirmId", color: "secondary", disabled: submitting, isSimple: false, component: Autocomplete_1.default, options: accountingFirms.map(function (c) { return ({ label: c.name, value: c.id }); }), placeholder: "Accounting Firm", title: "Accounting Firm" })] }), values.accountingFirmId && ((0, jsx_runtime_1.jsxs)(material_1.Box, { children: ["Accountant", (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "accountantId", color: "secondary", disabled: submitting, component: Autocomplete_1.default, isSimple: false, options: accountants
                                                    .filter(function (u) { return u.mainCompanyId === values.accountingFirmId; })
                                                    .map(function (u) { return ({ label: u.displayName, value: u.id }); }), placeholder: "Accountant", title: "Accountant" })] }))] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ type: "submit", disabled: submitting }, { children: "Assign" })) })] }) })));
            } })) })));
};
exports.default = AssignAccountantModal;
